import { IconProps, IconSizes } from "../icon-prop-types";

export const BaseballIcon = ({ size = "xsmall" }: IconProps) => {
  return (
    <svg width={IconSizes[size]} height={IconSizes[size]} viewBox={"0 0 24 24"}>
      <g id="Baseball" fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z"></path>
        <g fillRule="nonzero">
          <path
            d="M19.778 19.778c4.296-4.296 4.296-11.26 0-15.556-4.296-4.296-11.26-4.296-15.556 0-4.296 4.296-4.296 11.26 0 15.556 4.296 4.296 11.26 4.296 15.556 0zM5.636 18.364a9 9 0 1 1 .21.203l-.21-.203z"
            fill="#0A0B0D"
          ></path>
          <path
            d="M22.644 12.68A8.038 8.038 0 0 1 11.32 1.355l1.53 1.29a6.038 6.038 0 0 0 8.505 8.506l1.29 1.53zM9.565 21.504a9.209 9.209 0 0 0-2.5-4.57 9.209 9.209 0 0 0-4.57-2.5l.425-1.953a11.209 11.209 0 0 1 5.56 3.04 11.209 11.209 0 0 1 3.04 5.559l-1.955.424z"
            fill="#FF4054"
          ></path>
          <path
            d="M19.778 19.778c4.296-4.296 4.296-11.26 0-15.556-4.296-4.296-11.26-4.296-15.556 0-4.296 4.296-4.296 11.26 0 15.556 4.296 4.296 11.26 4.296 15.556 0zM5.636 18.364a9 9 0 1 1 .21.203l-.21-.203z"
            fill="#0A0B0D"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default BaseballIcon;
